/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {ProductListPageComponent} from './product-list-page.component';

@Component({
  standalone: true,
  imports: [ProductListPageComponent],
  selector: 'adn-product-route-page',
  template: `
    <adn-product-list-page
      [readOnly]="readOnly">
    </adn-product-list-page>
  `
})
export class ProductRoutePageComponent implements OnInit {
  readOnly = true;

  constructor(
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    this.readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetworkPermission(PERMISSIONS.politicalAdmin.apiKey, null, 'POLITICAL');
  }
}
